module.exports = __webpack_public_path__ + "media/v2/components/Contests/shared/Image/arrowNext-5c9794b2639971b0387a30a9a0ca1514.svg";